<template>
    <section class="comp_overview_graphs">
        <div class="comp_scroller">
            <div class="comp_content">
                <div class="wrp_comp_body" :class="[loading ? 'state-loading' : '']"
                     v-on:scroll="handleGlobalScroll($event)">
                    <part-chart-wrapper :heading="$t('obsazenost')" :customData="chartOccupancy.data"
                                        :customOptions="chartOccupancy.options" code="occupancy"
                                        ref="occupancy"></part-chart-wrapper>
                    <!--part-chart-wrapper :heading="$t('trzby')" :customData="chartEarnings.data" :customOptions="chartEarnings.options" code="earnings"></part-chart-wrapper-->
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
    name: 'overview-graphs',
    data() {
        return {
            loading: false,
            chartOccupancy: {
                data: {},
                options: {
                    scales: {
                        yAxes: [
                            {
                                ticks: {
                                    callback: function (value, index, values) {
                                        return value + '%';
                                    }
                                }
                            }
                        ]
                    }
                }
            },
            /*chartEarnings: {
                data: {},
                options: {
                    scales: {
                        yAxes: [
                            {
                                ticks: {
                                    max: 1000000,
                                    callback: function (value, index, values) {
                                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ",-";
                                    }
                                }
                            }
                        ]
                    }
                }
            }*/
        }
    },
    mounted() {
        let from = moment().month(+1).format('YYYY-MM-DD');
        let to = moment().format('YYYY-MM-DD');

        if (localStorage['chart-occupancy-from'] && localStorage['chart-occupancy-from'] !== 'undefined') {
            from = moment(localStorage['chart-occupancy-from']).format('YYYY-MM-DD');
        }

        if (localStorage['chart-occupancy-to'] && localStorage['chart-occupancy-to'] !== 'undefined') {
            to = moment(localStorage['chart-occupancy-to']).format('YYYY-MM-DD');
        }

        this.loading = true;

        axios({
            data: `{occupancyChart(date_from: "${from}", date_to: "${to}")}`
        }).then(response => {
            let responseData = JSON.parse(response.data.data.occupancyChart);
            let labels = [];
            let data = [];

            if (localStorage['chart-occupancy-type'] === 'monthly') {
                let x = 0;
                let y = 0;

                for (var d in responseData.dates) {
                    let date = new moment(d);

                    x += responseData.dates[d].occupied_rooms_count;
                    y += responseData.real_room_count;

                    if (date.format('YYYY-MM-DD') === moment(d).endOf('month').format('YYYY-MM-DD')) {
                        labels.push(this.$t(date.format('MMM')));
                        data.push(Math.round(100 * x / y));

                        x = 0;
                        y = 0;
                    }
                }
            } else {
                for (var d in responseData.dates) {
                    let date = new moment(d);

                    labels.push(date.format('D.M.'));
                    data.push(Math.round(100 * responseData.dates[d].occupied_rooms_count / responseData.real_room_count));
                }
            }

            this.chartOccupancy.data = {
                labels: labels,
                datasets: [
                    {
                        data: data
                    }
                ]
            };
        }).catch(error => {
            this.showError(error)
        }).then(() => {
            this.loading = false;
            this.$refs.occupancy.$el.querySelector('.wrp_part_body').querySelector('div').setAttribute('style', 'width: ' + this.chartOccupancy.data.datasets[0].data.length * 6 / 16 + 'rem');
        });
    }
}
</script>



// WEBPACK FOOTER //
// src/templates/comp/overview-graphs.vue